import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttributionFromUrl } from "@/lib/attribution";

export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    // Capture ?ref= / ?referral_code= / utm_* on every navigation, since a visitor
    // may land on any page before eventually reaching signup or a lead form.
    captureAttributionFromUrl();
  }, [pathname, search]);
  return null;
}
